import { Box, Button } from '@codeparva/ui-components-library';
import { navigate } from 'gatsby';
import React from 'react';
import { ClickableText } from '../../../../components/clickableText/ClickableText';
import {
  SectionCardTitle,
  SectionContentTitle,
} from '../../../../components/textVariations';
import { mobilescreensize } from '../../../../utilities/constants';
import { useWindowDimensions } from '../../../../utilities/Dimensions';
import { Icon } from '../../../../utilities/icomoon-css';
export const SignUpError = (contactDetails: any) => {
  const { width } = useWindowDimensions();

  const facilityDetails = [
    {
      iconName: 'tfw-geo-1-cp',
      text: contactDetails.contactDetails.facilityDetails.facilityAddress,
      type: 'address',
      url: contactDetails.contactDetails.facilityDetails.googleMapsUrl,
    },
    {
      iconName: 'tfw-call-cp',
      text: contactDetails.contactDetails.phoneNumber,
      type: 'phone',
    },
    {
      iconName: 'tfw-email-1-cp',
      text: contactDetails.contactDetails.emailID,
      type: 'email',
    },
  ];
  const getClickableText = (clickableTextProps: any) => {
    return (
      <div className="contactSection">
        <Icon name={clickableTextProps.iconName} color="black"></Icon>
        <ClickableText
          text={clickableTextProps.text}
          type={clickableTextProps.type}
          url={clickableTextProps.url && clickableTextProps.url}
          className="pl-4 has-text-black"
        ></ClickableText>
      </div>
    );
  };

  return (
    <div className="signUpErrorContainer">
      <Box p={width <= mobilescreensize ? 5 : 6}>
        <div className="signUpTitlesection">
          <div className="signUpMessage">
            <SectionCardTitle>
              You have already created an account with this email.
            </SectionCardTitle>
          </div>
          <div className="signUpButton">
            <Button
              className="cp-primary-button-highlighted buttonColor"
              onClick={() => {
                navigate('../login');
              }}
            >
              Click here to Sign In
            </Button>
          </div>
        </div>
        <div className="signUpFacilityContactSection">
          <SectionContentTitle>
            Please contact the facility, if you are facing any problem with your
            credentials.
          </SectionContentTitle>
          {facilityDetails.map((contact: any) => {
            return getClickableText(contact);
          })}
        </div>
      </Box>
    </div>
  );
};
